var path = 'infrastructure/directives/views/spin.html';
var html = "<span class=spin-container> <span ng-show=active class=spinny> <i class=\"fa fa-spinner fa-spin fa-lg\"></i> </span> </span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/views/spin.html
// module id = 1025
// module chunks = 1